module.exports = __webpack_public_path__ + "img/jr57.c282b7b1.png";